<template>
  <div class="container-document-form">
    <form-accordion :title="$t('businessDocuments.request_desc_read')">
      <div class="row" v-if="document.Description !== ''">
        <div class="form-group col-sm-12">
          <textarea class="form-control inputAccordionForm" :value="document.Description"
                    style="margin-top: 4px;" disabled>
          </textarea>
        </div>
      </div>
      <div class="row" v-else>
        <div class="form-group col-sm-12">
          <span>{{ $t('common.general_msg_none') }}</span>
        </div>
      </div>
    </form-accordion>
    <div class="row">
      <div class="col-md-12" style="font-weight: bold; font-size: 14px;">
        {{ $t('businessDocuments.form_document_send_title') }}
      </div>
    </div>
    <br/>

    <div v-if="!isSmartphoneOS">
      <!-- <b-form-group>
        <b-form-radio class="creationFormBtnRadio" v-model="locationTypeFile"
                      :name="'radios-locationTypeFile' + document.id" value="1">{{ $t('common.local_location') }}
        </b-form-radio>
        <b-form-radio style="margin-left: 35px;" class="creationFormBtnRadio" v-model="locationTypeFile"
                      :disabled="$engine.rights.rightIs('attachment_consulter', false)"
                      :name="'radios-locationTypeFile' + document.id" value="2">{{ $t('common.moneyroad_location') }}
        </b-form-radio>
        <i style="float:right" v-if='fileNameArray.length != 0'>{{ $t('businessDocuments.othr_pages_label') }}</i>
      </b-form-group> -->

      <div class="row">
        <div class="form-group col-sm-12 col-lg-5">
          <div class="row blackBottomButton" v-if='locationTypeFile === "1"'>
            <div class="form-group col-sm-12">
              <f7-button round class="invoiceButton buttonAccordionForm"
                @click="showFileSelectionWindow(locationTypeFile)">
                {{ $t('attachments.import_file_singular') }}
              </f7-button>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-sm-12">
              <select class="form-control" id="sel2" readonly v-model="fileId"
                      v-if='locationTypeFile === "2"' @change="loadCloudFile()">
                <option value="" default disabled>
                  {{ this.hasCloudAttachments ? $t('common.click_to_select_file') : $t('attachments.no_document') }}
                </option>
                <option v-for="cloudDoc in cloudDocs" :key="cloudDoc.id" :value="cloudDoc.id">
                  {{ cloudDoc.name }}
                </option>
              </select>
              <input class="item-input hiddenElementAllSize local-file-input" ref="fileButton" @change="executeOCR" type="file"/>
              <div v-if="fileArrayError" style="color:red;">
                {{ $t('errors.is_mandatory', {mandatoryValue: $t('attachments.import_file_singular') }) }}
              </div>
            </div>
          </div>
        </div>
        <div class="form-group col-sm-12 col-lg-6" v-if='fileNameArray.length != 0'>
          <table class="table table-striped table-bordered" style="table-layout:fixed">
            <thead>
              <tr>
                <th scope="col" style="width:70%">{{ $t('businessDocuments.document_lst') }}</th>
                <th scope="col">{{ $t('common.action_label') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="filename in this.fileNameArray">
                <td class="textOverflow">{{ filename }}</td>
                <td>
                  <a href="#" @click="removeFile(filename)">
                    <i class="icon button-delete f7-icons">close</i>
                    <span class="labelDelete">{{ $t('common.rm_label') }}</span>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div v-if="isSmartphoneOS">
      <div class="row">
        <div class="col-sm-12">
          <button round
            class="button-action-main greenButton"
            :title="$t('creation_forms.tke_doct_pctr')"
            @click="scanDocument($event)">
            <span>{{ $t('creation_forms.tke_doct_pctr') }}</span>
          </button>
        </div>
      </div>

      <div class="row">
        <span class="labelSub greyLabel">{{ $t('common.or_label_maj') }}</span>
      </div>
      <div class="row form-group">
        <div class="col-sm-12">
          <button round
            class="button-action-sub greyButton"
            :title="$t('businessDocuments.local_location_small')"
            :disabled="$engine.rights.rightIs('attachment_consulter', false)"
            @click="showFileSelectionWindow('1')">
            <span>{{ $t('businessDocuments.local_location_small') }}</span>
          </button>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-sm-12">
          <button round
            class="button-action-sub greyButton"
            :title="$t('businessDocuments.moneyroad_location_small')"
            @click="filesPicker($event)">
            <span>{{ $t('businessDocuments.moneyroad_location_small') }}</span>
          </button>
        </div>
      </div>

      <!-- File Type -->
      <div class="row">
        <div class="form-group col-sm-6" v-if='this.locationTypeFile != "0" && false'>
          <label>{{ $t('businessDocuments.document_name') }}</label>
          <input class="form-control inputAccordionForm" type="text"
            :placeholder="$t('creation_forms.slct_a_fl')"
            readonly
            id="application-file-input-mobile"
            v-model="fileNameLabel">
          </input>
        </div>
        <div class="form-group col-sm-12" v-if='this.fileNameArray.length != 0'>
          <i>{{ $t('businessDocuments.othr_pages_label') }}</i>
          <table class="table table-striped table-bordered" style="table-layout:fixed">
            <thead>
              <tr>
                <th scope="col" style="width:70%">{{ $t('businessDocuments.document_lst') }}</th>
                <th scope="col">{{ $t('common.action_label') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="filename in this.fileNameArray">
                <td class="textOverflow">{{ filename }}</td>
                <td>
                  <a href="#" @click="removeFile(filename)">
                    <i class="icon button-delete f7-icons">close</i>
                    <span class="labelDeleteMobile">{{ $t('common.rm_label') }}</span>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <input class="item-input hiddenElementAllSize local-file-input" ref="fileButton" @change="executeOCR" type="file"/>
      </div>
    </div>
    <div class="row">
      <form-write-group-label-input
        :inputLabel="$t('common.rfrnc')" :placeholderValue="$t('common.rfrnc')"
        v-model="fileReference">
      </form-write-group-label-input>
      <form-write-group-label-input
        :inputLabel="$t('businessDocuments.creation_date') + ' (MM-YYYY)'" :placeholderValue="$t('common.slct_date')"
        v-model="creationDate"
        :regexpErrorIndicator="creationDateRegexpError">
      </form-write-group-label-input>
    </div>
    <!-- Document Information -->
    <div v-if="this.serializeGet.length != 0">
      <form-accordion :title="$t('businessDocuments.doc_details')" :open="ocrDone">
        <div class="row">
          <template v-for="value in serializeGet">
            <template v-if="value.change === '1' || (value.change === '0' && document.Serialize[value.name])">
              <template v-if="value.type === 'object'">
                <form-write-group-label-input v-for="(subvalue, subindex) in value[0]"
                  :key="subindex"
                  :inputLabel="$t('businessDocuments.serialize.' + document.Type + '.' + subindex.name)"
                  v-model="document.Serialize[value.name][0][subindex.name]">
                </form-write-group-label-input>
              </template>
              <form-write-group-label-input v-else-if="value.type === 'date'"
                :inputLabel="$t('businessDocuments.serialize.' + document.Type + '.' + value.name)"
                :placeholderValue="$t('common.slct_date')"
                v-model="document.Serialize[value.name]" :inputType="'date'">
              </form-write-group-label-input>
              <div v-else-if="value.type === 'boolean' && value.change === '0'" class="form-group col-sm-6">
                <label>{{ $t('businessDocuments.serialize.' + document.Type + '.' + value.name) }}</label>
                <div v-if="document.Serialize[value.name] === '0'">
                  <i class="icon fa fa-check" style="color:green;font-size:30px;"></i>
                  &nbsp;&nbsp;{{ $t('common.status.valid_control_key') }}
                </div>
                <div v-else>
                  <i class="icon fa fa-ban" style="color:red;font-size:30px;"></i>&nbsp;&nbsp;
                  <span v-if="document.Serialize[value.name] === '1'">
                    {{ $t('errors.invalid_control_key') }}
                  </span>
                  <span v-else-if="document.Serialize[value.name] === '2'">
                    {{ $t('errors.out_of_date') }}
                  </span>
                  <span v-else-if="document.Serialize[value.name] === '3'">
                    {{ $t('errors.invalid_control_key_out_of_date') }}
                  </span>
                </div>
              </div>
              <form-write-group-label-input v-else
                :inputLabel="$t('businessDocuments.serialize.' + document.Type + '.' + value.name)"
                v-model="document.Serialize[value.name]">
              </form-write-group-label-input>
            </template>
          </template>
        </div>
      </form-accordion>

      <hr />
    </div>
    <!--<form-accordion :title="$t('common.add_msg')">
      <div class="row">
        <div class="form-group col-sm-12">
          <textarea class="form-control inputAccordionForm" v-model="formMessage"
                    :placeholder="$t('common.general_msg')" style="margin-top: 4px;">
          </textarea>
        </div>
      </div>
    </form-accordion>-->
    <div class="row">
      <div class="col-md-3 justify-content-end">
        <button round
          class="button-action firstButtonMarginTop col-md milkyBlockBlack"
          @click="returnBusinessDocument">
          <i class="icon fa fa-paper-plane"></i>
          {{ $t('businessDocuments.form_document_send_button') }}
        </button>
        <br/><br/>
      </div>
    </div>
  </div>
</template>
<script>
import documentSerialize from '@/helpers/documentSerialize.json'
import {errorMessageAlert} from '@/helpers/alert'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import moment from 'moment'
import Services from '@/helpers/services'
import {verifyRegexpValues, checkErrorFlag} from '@/helpers/validator'

export default {
  name: 'BusinessDocumentReturnForm',
  props: ['document', 'cloudDocs', 'sellers'],
  components: {
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  data () {
    return {
      creationDate: '',
      // creationDateError: false,
      creationDateRegexpError: false,
      fieldsTypeMap: {},
      fileArrayError: false,
      fileContentArray: [],
      fileId: '',
      fileNameArray: [],
      fileNameLabel: '',
      fileReference: '',
      formMessage: '',
      infosCompl: '',
      isSmartphoneOS: false,
      locationTypeFile: '1',
      ocrDone: false,
      serializeGet: []
    }
  },
  created () {
    let that = this
    this.serializeGet = documentSerialize[this.document.Type].fields
    for (var j = 0; j < this.serializeGet.length; j++) {
      let field = this.serializeGet[j]
      this.fieldsTypeMap[field.name] = field.type
    }
    for (var i = 0; i < this.serializeGet.length; i++) {
      this.document.Serialize[this.serializeGet[i].name] = ''
    }
    if (this.$f7.device.os === 'android' || this.$f7.device.os === 'ios') {
      this.isSmartphoneOS = true
      this.locationTypeFile = '0'
    }
    this.cloudDocsPicker = this.$f7.picker({
      input: '#bookCloudDocs',
      rotateEffect: true,
      cols: [
        {
          textAlign: 'center',
          values: Object.keys(that.cloudDocs)
        }
      ],
      onClose: function (p) {
        that.fileId = that.cloudDocs[p.value].id
        that.loadCloudFile()
      }
    })
  },
  computed: {
    hasCloudAttachments () {
      return (Object.keys(this.cloudDocs).length > 0)
    }
  },
  methods: {

    filesPicker (e) {
      this.locationTypeFile = '2'
      e.stopPropagation()
      this.cloudDocsPicker.open()
    },
    // Load file from browser and start OCR, if current parameters allow it
    executeOCR (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 2000000) {
        var reader = new FileReader()
        reader.onload = (event) => {
          this.fileContent = event.target.result
          this.fileContentArray.push(event.target.result)
          if (this.$engine.settings.get(Services.DOCUMENTSERVICE).ocrActivation === '0' || this.fileContentArray.length > 1) {
            console.log('OCR features are currently under maintenance. Please come again later.')
          } else {
            this.$f7.showPreloader(this.$i18n.t('sent.ocr_loading', {request_type: this.$i18n.t('servicesNames.business_doc_sing')}))
            return this.$engine.services.ocr(
              this.$engine.user.get().id,
              '',
              event.target.result,
              'pdf',
              'scan',
              this.document.Type
            ).then(response => {
              this.$f7.hidePreloader()
              this.$f7.modal({
                title: this.$i18n.t('sent.ocr_end'),
                text: '<span class="preloader"></span>'
              })
              this.$f7.hidePreloader()
              this.$f7.closeModal()
              response = response.data.DocumentData
              let attributes = Object.keys(response)
              for (var i = 0; i < attributes.length; i++) {
                if (attributes[i] === 'EMISSION_DATE') {
                  let dateGet = response[attributes[i]].value.substring(3, response[attributes[i]].value.length)
                  dateGet = dateGet.replace('/', '-')
                  this.creationDate = dateGet
                } else {
                  if (this.fieldsTypeMap[attributes[i]] === 'date') {
                    let dateGetArray = response[attributes[i]].value.split('-')
                    this.document.Serialize[attributes[i]] = new Date(dateGetArray[2] + '-' + dateGetArray[1] + '-' + dateGetArray[0])
                  } else {
                    this.document.Serialize[attributes[i]] = response[attributes[i]].value
                  }
                }
              }
              this.ocrDone = true
            })
            .catch(err => {
              this.$f7.hidePreloader()
              this.$f7.closeModal()
              this.$f7.alert(this.$i18n.t('errors.too_important_tilt') + ' ' + err)
              console.log(this.$i18n.t('errors.too_important_tilt') + ' ' + err)
            })
          }
        }
        reader.readAsDataURL(files[0])
        this.fileName = files[0].name
        this.fileNameArray.push(files[0].name)
      } else {
        this.$f7.alert(this.$i18n.t('creation_forms.file_size') + Math.round(files[0].size / 1000) + this.$i18n.t('creation_forms.max_file_size') + '2000 Kb',
          this.$i18n.t('creation_forms.max_size_title'))
      }
      this.$refs.fileButton.value = ''
    },
    loadCloudFile () {
      const that = this
      this.$engine.attachments.download(that.fileId.toString())
        .then(response => {
          that.fileNameArray.push(response.data.document_name)
          that.fileContentArray.push(response.data.document_data)
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      this.fileId = ''
    },
    removeFile (filename) {
      let index = this.fileNameArray.indexOf(filename)
      this.fileNameArray.splice(index, 1)
      this.fileContentArray.splice(index, 1)
    },
    returnBusinessDocument () {
      if (!this.validateForm()) {
        this.$f7.alert(this.$i18n.t('errors.errors_in_form_details'), this.$i18n.t('errors.errors_in_form'))
        return
      }
      this.$f7.showPreloader(this.$i18n.t('loading.sending_document'))
      let that = this
      let fileContentToSend = that.fileContentArray[0]
      // fileContentToSend = fileContentToSend.substring(fileContentToSend.indexOf(',') + 1, fileContentToSend.length)
      if (that.fileContentArray.length > 1) {
        for (var i = 1; i < that.fileContentArray.length; i++) {
          fileContentToSend += ';' + that.fileContentArray[i]
        }
      }

      let documentSerialize = {}
      if (that.document.Serialize) {
        documentSerialize = that.document.Serialize
      }

      let jsonToSend = {
        Serialize: documentSerialize,
        person_information: that.document.person_information
      }

      let attachmentDate = ''
      if (that.creationDate) {
        attachmentDate = moment('01-' + that.creationDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
      }
      let jsonToCreate = {
        Receiver: that.document.Correspondent,
        IdGroup: that.document.IdGroup,
        GroupLabelReference: that.document.GroupReference,
        AttachmentId: that.document.DocumentIdentifier,
        AttachmentName: that.document.Name,
        AttachmentDescription: that.formMessage,
        AttachmentReference: that.fileReference,
        AttachmentType: that.document.Type,
        AttachmentDate: attachmentDate,
        AttachmentData: fileContentToSend,
        AttachmentOthers: jsonToSend,
        AttachmentRequestName: that.formMessage,
        AttachmentRequestDescription: that.formMessage
      }
      that.$engine.services.businessDocuments.returnDocument(jsonToCreate)
      .then(response => {
        that.status = response.status
        if (response.status === 200) {
          that.$f7.hidePreloader()
          that.$f7.modal({
            title: that.$i18n.t('success.document_sent'),
            text: '<i class="icon fa fa-check"></i>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            that.$emit('reloadFolder')
            // loadPage(that, {url: '/inbox/'})
          }, 2000)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    showFileSelectionWindow (fileType) {
      this.locationTypeFile = '1'
      if (fileType === '1') {
        this.$refs.fileButton.click()
      }
    },
    validateForm () {
      let flagsList = {
        'fileNameArray': false
      }
      // let mandatoryValues = ['creationDate']
      let regexpValues = {
        'creationDate': 'monthYearDate'
      }
      // flagsList = verifyMandatoryValues(mandatoryValues, flagsList, this)
      flagsList = verifyRegexpValues(regexpValues, flagsList, this)
      if (this.fileNameArray.length === 0) {
        this.fileArrayError = true
        flagsList.fileNameArray = true
      }
      let errorFlag = checkErrorFlag(flagsList)
      return !errorFlag
    }
  }
}

</script>
